/** Characters that must not appear in passwords */
export const DISALLOWED_PASSWORD_CHARS = /["`<>?!^*()_\-+={}|\\[\]\s]/;

/** Allowed special characters for the "one special" rule */
export const ALLOWED_SPECIAL_CHARS = '@#$%&.;:,/~';

const PASSWORD_PATTERN = new RegExp(
  `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[${ALLOWED_SPECIAL_CHARS.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}])[A-Za-z0-9${ALLOWED_SPECIAL_CHARS.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}]{12,}$`
);

export const PASSWORD_RULES_HINT =
  'At least 12 characters, with 1 uppercase, 1 lowercase, 1 number, and 1 special character ' +
  `(${ALLOWED_SPECIAL_CHARS.split('').join(' ')}). ` +
  'Not allowed: " < > ? ! ^ * ( ) _ - + = { } | \\ [ ] ` or spaces.';

export function validatePassword(password) {
  if (!password) return 'Please enter a password.';
  if (password.length < 12) return 'Password must be at least 12 characters long.';
  if (DISALLOWED_PASSWORD_CHARS.test(password)) {
    return 'Password contains disallowed characters (e.g. " < > ? ! ^ * ( ) _ - + = { } | \\ [ ] ` or spaces).';
  }
  if (!/[A-Z]/.test(password)) return 'Password must include at least one uppercase letter.';
  if (!/[a-z]/.test(password)) return 'Password must include at least one lowercase letter.';
  if (!/[0-9]/.test(password)) return 'Password must include at least one number.';
  const hasAllowedSpecial = [...password].some(
    (ch) => ALLOWED_SPECIAL_CHARS.includes(ch)
  );
  if (!hasAllowedSpecial) {
    return `Password must include at least one special character: ${ALLOWED_SPECIAL_CHARS}`;
  }
  if (!PASSWORD_PATTERN.test(password)) {
    return 'Password does not meet all requirements.';
  }
  return null;
}
